// extracted by mini-css-extract-plugin
export var buttonIcon = "Category-module--buttonIcon--eb68d";
export var firstSection = "Category-module--firstSection--77e1a";
export var hiderStyle = "Category-module--hiderStyle--498d1";
export var main = "Category-module--main--5d7af";